<template>
  <div id="flow-calculator-tool">
    <div class="mainWrapper">
      <div class="headerLeft"><span><translate>Units</translate></span></div>
      <div id="unit">
        <Multiselect id="selectUnits" ref="selectUnits" @changeSelect="onChangeunit"></Multiselect>
      </div>
      <div class="main">
        <div class="left">
          <div class="innerDiv">
            <div class="label"><span><translate>Inner Diameter</translate></span> [<span id="u1">mm</span>]</div>
            <input type="number" id="inputInnerDiameter" ref="inputInnerDiameter" @change="onChangeinnerDiameterInput"/>
            <Slider ref="innerDiameter" @update="onChangeinnerDiameter" :lazy="false" :min="4" :max="1000" :value="4" :format="formatterDiameter" :step="-1"></Slider>
            <br><br>
            <div class="label"><span><translate>Flow Velocity</translate></span> [<span id="u2">m/s</span>]
            </div>
            <input type="number" id="inputFlowVelocity" ref="inputFlowVelocity" @change="onChangeinputFlowVelocity"/>
            <Slider ref="flowVelocity" @update="onChangeflowVelocity" :lazy="false" :min="0.1" :max="10" :value="0.1" :interval="0.1" :format="formatterFlowVelocity" :step="-1"></Slider>

          </div>
        </div>
        <div class="right">
          <div class="innerDiv">
            <div class="label" style="margin-bottom: 27px;"><span><translate>Flow Rate</translate></span></div>
            <div class="row"><span id="u4">l/min</span><span id="r1" class="result">0.08</span>
            </div>
            <div class="row"><span id="u5">m<sup>3</sup>/h</span><span id="r2" class="result">0</span></div>
            <div class="row"><span id="u_6">gpm (US gallons)</span><span id="r3" class="result">0.02</span></div>
            <div class="row"><span id="u_8">gpm (British gallons)</span><span id="r5" class="result">0.02</span>
            </div>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="left">
          <div class="innerDiv">
            <div class="label"><span data-v-cf362b7a=""><translate>Pipe Length</translate></span> [<span id="u3">m</span>]
            </div>
            <input type="number" id="inputPipeLength" ref="inputPipeLength" @change="onChangeinputPipeLength"/>
            <Slider ref="pipeLength" @update="onChangepipeLength" :lazy="false" :min="1" :max="1000" :value="1" :format="formatterPipeLength" :step="-1"></Slider>
          </div>
        </div>
        <div class="right">
          <div class="innerDiv" style="padding-bottom: 0px;">
            <div class="label" style="margin-bottom: 27px;"><span><translate>Pressure Loss</translate></span></div>
            <div class="row"><span id="u7">bar</span><span id="r4" class="result">0</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import $ from 'jquery'
import { useGettext } from "@jshmrtn/vue3-gettext";
import VueSlider from '@vueform/slider'
import '@vueform/slider/themes/default.css'

import Multiselect from "@/components/multi_select";

let $gettext;
let valInnerDiameter = 4,
    valFlowVelocity = 0.1,
    valPipeLength = 1;
export default {
  name: "FlowCalculator",
  components: {
    Slider: VueSlider,
    Multiselect: Multiselect
  },
  props: ["myvm"],
  setup: function () {
    $gettext = useGettext().$gettext;
    window.$gettext = useGettext();
    const language = useGettext();
    return {
      language,
    };
  },
  created: function() {
    var t = this;
    setTimeout(t.init, 4)
  },
  methods: {
    init: function() {
          var that = this;
          that.$refs.selectUnits.setOptions([{
            label: $gettext("Metric"),
            value: "Eu"
          }, {
            label: $gettext("Imperial"),
            value: "Us"
          }]);
          this.setUnits(),
          this.doCalc()
    },
    onChangeinnerDiameter: function (val) {
      valInnerDiameter = Math.round(val);
      // console.log(val);

      this.doCalc();
    },
    onChangeflowVelocity: function (val) {
      valFlowVelocity = Math.round(val*10)/10;
      // $("#inputFlowVelocity").val(valFlowVelocity);
      this.doCalc();
    },
    onChangepipeLength: function (val) {
      valPipeLength = Math.round(val);
      // $("#inputPipeLength").val(valPipeLength);
      this.doCalc();
    },
    onChangeinnerDiameterInput: function (val) {
      if(isNaN(this.$refs.inputInnerDiameter.value)) return;
      if (this.$refs.selectUnits.val() == "Us") {
        this.$refs.innerDiameter.update(this.$refs.inputInnerDiameter.value * 25.4);
      } else {
        this.$refs.innerDiameter.update(this.$refs.inputInnerDiameter.value);
      }
    },
    onChangeinputFlowVelocity: function (val) {
      if(isNaN(this.$refs.inputFlowVelocity.value)) return;
      if (this.$refs.selectUnits.val() == "Us") {
        this.$refs.flowVelocity.update(this.$refs.inputFlowVelocity.value * .3048);
      } else {
        this.$refs.flowVelocity.update(this.$refs.inputFlowVelocity.value);
      }
    },
    onChangeinputPipeLength: function (val) {
      if(isNaN(this.$refs.inputPipeLength.value)) return;
      if (this.$refs.selectUnits.val() == "Us") {
        this.$refs.pipeLength.update(this.$refs.inputPipeLength.value * .3048);
      } else {
        this.$refs.pipeLength.update(this.$refs.inputPipeLength.value);
      }
    },
    onChangeunit: function(t) {
      var that = this;
      setTimeout(function () {
        that.setUnits();
        // console.log("that.$refs.innerDiameter.val",that.$refs.innerDiameter.value);
        that.$refs.innerDiameter.update(valInnerDiameter);
        that.$refs.flowVelocity.update(valFlowVelocity);
        that.$refs.pipeLength.update(valPipeLength);
        // valInnerDiameter = that.$refs.innerDiameter.value;
        // valFlowVelocity = that.$refs.flowVelocity.value;
        // valPipeLength = that.$refs.pipeLength.value;
        // console.log(that.$refs.innerDiameter.value=5);
            that.doCalc();
      }, 2);
    },
    doCalc: function() {
      var that = this;

      var t = valInnerDiameter
          , e = valFlowVelocity
          , n = 10 * e * Math.pow(t / 100, 2) * Math.PI / 4 * 60
          , i = valPipeLength
          , o = .02 * i / t * 1e3 / 2 * Math.pow(e, 2) / 100
          , a = this.round2(n)
          , s = this.round2(60 * n / 1e3)
          , u = n / 3.7854;

      // u = "Eu" !== this.$refs.selectUnits.value.value ? this.round2(u / 1.2009) : this.round2(u);
      u = this.round2(u);
      var u2 = this.round2(u / 1.2009);
      var l = "Eu" !== this.$refs.selectUnits.value.value ? this.round2(o * 14.503773773) : this.round2(o);
      $("#r1").text(a);
      $("#r2").text(s);
      $("#r3").text(u); //us gallons
      $("#r5").text(u2);//br gallons
      $("#r4").text(l);
    },
    setUnits: function() {
      var that = this;
      var i = ["Eu", "Us"];
          i["Eu"] = [$gettext("mm"), $gettext("m/s"), $gettext("m"), $gettext("l/min"), $gettext("m<sup>3</sup>/h"), $gettext("gpm/U.S."), $gettext("bar")];
          i["Us"] = [$gettext("inch"), $gettext("ft/s"), $gettext("ft"), $gettext("l/min"), $gettext("m<sup>3</sup>/h"), $gettext("gpm/Imp."), $gettext("PSI")];
      for (var t = this.$refs.selectUnits.val(), e = 0; e < 7; ++e)
        $("#u" + (e + 1)).html(i[t][e]);
    },
    formatterDiameter: function (t) {
      if (this.$refs.selectUnits.val() !== "Us") {
        $("#inputInnerDiameter").val(Math.round(t));
        return Math.round(t);
      } else {
        $("#inputInnerDiameter").val(Math.round(t / 25.4 * 100) / 100);
        return Math.round(t / 25.4 * 100) / 100;
      }
    },
    formatterFlowVelocity: function (t) {
      if (this.$refs.selectUnits.val() !== "Us") {
        $("#inputFlowVelocity").val(Math.round(t*10)/10);
        return Math.round(t*10)/10;
      } else {
        console.log("===> "+Math.round(t / .3048 * 100) / 100);
        $("#inputFlowVelocity").val(Math.round(t / .3048 * 100) / 100);
        return Math.round(t / .3048 * 100) / 100
      }
    },
    formatterPipeLength: function (t) {
      if (this.$refs.selectUnits.val() !== "Us") {
        $("#inputPipeLength").val(Math.round(t));
        return Math.round(t);
      } else {
        $("#inputPipeLength").val(Math.round(t / .3048 * 100) / 100);
        return Math.round(t / .3048 * 100) / 100
      }
    },
    round2: function(t) {
      return Math.round(100 * t) / 100
    }

  }

}
</script>
<style>
#app {
  font-family: Avenir,Helvetica,Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.slider-horizontal {
  margin-left: 23px;
  height: 4px!important;
}
.slider-base {
  background-color: #0364a6!important;
}
.slider-tooltip {
  background-color: #00afff!important;
  border-radius:0!important;
  border-color: #00afff!important;
}
.slider-handle {
  cursor: pointer!important;
}
.slider-horizontal .slider-tooltip-top{
  width:50px!important;
  height:40px!important;
  bottom: -12px;
  padding-top: 9px;
  padding-left:0!important;
  padding-right:0!important;
  border:0!important;
}
.slider-horizontal .slider-tooltip-top:before {
  display:none;
}
.slider-connect {
  background-color: #00afff!important;
}
.vue-slider {
  padding: 7px 25px!important;
}
.vue-slider-rail {
  background-color: #0364a6!important;
}
.vue-slider-dot-handle, .vue-slider-process {
  background-color: #00afff!important;
}
.vue-slider-dot {
  width: 50px!important;
  height: 40px!important;
}
.vue-slider-dot-handle {
  border-radius: 0!important;
  border: 0!important;
}
.vue-slider-dot-tooltip-show, .vue-slider-dot:hover .vue-slider-dot-tooltip {
  opacity: 1;
  visibility: visible;
}
.vue-slider-dot-tooltip-top {
  top: 34px;
}
.vue-slider-dot-tooltip {
  cursor: pointer;
}
.vue-slider-dot-tooltip-show .vue-slider-dot-tooltip-inner, .vue-slider-dot:hover .vue-slider-dot-tooltip .vue-slider-dot-tooltip-inner {
  transform: scale(1);
}
.vue-slider-dot-tooltip {
  visibility: visible!important;
}
.vue-slider-dot-tooltip-inner {
  background: none!important;
  box-shadow: none!important;
}
.vue-slider-dot-tooltip-inner-top {
  transform-origin: 50% 100%;
}
.vue-slider-dot-tooltip-text {
  font-family: DINNextLTW01-Medium;
}

</style>
<style scoped>

@font-face {
  font-family: "DINNextLTW05-Regular";
  src: url("../assets/DINNextLTW05-Regular.eot?#iefix");
  src:
      url("../assets/DINNextLTW05-Regular.eot?#iefix") format("eot"),
      url("../assets/DINNextLTW05-Regular.woff2") format("woff2"),
      url("../assets/DINNextLTW05-Regular.woff") format("woff"),
      url("../assets/DINNextLTW05-Regular.ttf") format("truetype");
}

@font-face {
  font-family: "GlyphaLTW05-65Bold";
  src: url("../assets/GlyphaLTW05-65Bold.eot?#iefix");
  src:
      url("../assets/GlyphaLTW05-65Bold.eot?#iefix") format("eot"),
      url("../assets/GlyphaLTW05-65Bold.woff2") format("woff2"),
      url("../assets/GlyphaLTW05-65Bold.woff") format("woff"),
      url("../assets/GlyphaLTW05-65Bold.ttf") format("truetype");
}

@font-face {
  font-family: "DINNextLTW01-Medium";
  src: url("../assets/DINNextLTW01-Medium.eot?#iefix");
  src:
      url("../assets/DINNextLTW01-Medium.eot?#iefix") format("eot"),
      url("../assets/DINNextLTW01-Medium.woff2") format("woff2"),
      url("../assets/DINNextLTW01-Medium.woff") format("woff"),
      url("../assets/DINNextLTW01-Medium.ttf") format("truetype");
}

.mainWrapper {
  width: 90vw;
  margin-left: auto;
  margin-right: auto;
  max-width: 1280px;
}
.headerLeft {
  width: 100%;
  text-align: left;
}
#unit {
  max-width: 320px;
}
.main {
  margin-top: 30px;
  border: 1px solid #bbb;
  padding: 0;
  font-family: DINNextLTW05-Regular,Arial,sans-serif;
  text-align: left;
}
.left, .right {
  display: inline-block;
  padding: 0;
}
.left {
 width: 68%;
 border-right: 1px solid #bbb;
}
.left .innerDiv {
  padding-bottom: 35px;
}
.right {
  width: 31%;
  vertical-align: top;
}
.innerDiv {
 padding: 30px;
}
.label {
  margin-bottom: 30px;
  font-size: 19px;
  font-family: DINNextLTW01-Medium,Arial;
  text-align: left;
}
.row {
  width: 100%;
  text-align: left;
  margin-bottom: 14px;
}
.result {
  float: right;
  font-weight: 700;
}
.slidergrid {
  //display: inline-block;
  //width: 70%;
  margin-bottom: 30px;
}
input {
  width: 100px;
  max-width: 100px;
  padding: 10px;
  margin-bottom: 30px;

  border:0!important;
  margin-left: -2px;
  font-family: DINNextLTW05-Regular,Arial,sans-serif;
  font-weight: bold;
  background-color:#f0f0f0;
}
@media (max-width: 728px){
  .mainWrapper {
    width: 94vw;
  }
  .left, .right {
    width: 100%;
  }
  .left .innerDiv {
    padding-left: 40px;
    padding-right: 40px;
  }
  .right {
    max-width: unset;
    border-top: 1px solid #bbb;
  }
}


</style>